import "./App.css";
import React, { useEffect, useState } from "react";
import SideBar from "./components/sidebar/SideBar";
import ServicePage from "./components/service/ServicePage";
import ResumePage from "./components/resume/ResumePage";
import PortfolioPage from "./components/portfolio/PortfolioPage";
import HomePage from "./components/home/HomePage";
import AboutPage from "./components/about/AboutPage";
import ContactPage from "./components/contact/ContactPage";
import { useLocation } from "react-router-dom";

function App() {
  const location = useLocation();

  // useEffect(() => {
  //   window.gtag("config", "G-WDZTYJZQ46", {
  //     page_path: location.pathname,
  //   });
  // }, [location]);

  // Google Analytics tracking for initial load + hash changes
  useEffect(() => {
    // Track initial page load with hash
    window.gtag("config", "G-WDZTYJZQ46", {
      page_path: window.location.pathname + window.location.hash,
    });

    const onHashChange = () => {
      window.gtag("config", "G-WDZTYJZQ46", {
        page_path: window.location.pathname + window.location.hash,
      });
    };

    window.addEventListener("hashchange", onHashChange);

    return () => {
      window.removeEventListener("hashchange", onHashChange);
    };
  }, [location]);

  const [darkMode, setDarkMode] = useState(false);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  useEffect(() => {
    document.body.style.backgroundColor = darkMode ? "#1F2937" : "#ffffff";
    document.body.style.transition = "background-color 0.5s ease"; // <- Add smooth transition
  }, [darkMode]);

  return (
    <div className={darkMode ? "app dark bg-gray-800" : "app"}>
      <SideBar darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      {/* <button onClick={toggleDarkMode} className="toggle-btn">
        {darkMode ? '☀️' : '🌙'}
      </button> */}

      {/* <main className="main">
        <HomePage />
        <AboutPage />
        <ServicePage />
        <ResumePage />
        <PortfolioPage />
        <ContactPage />
      </main> */}
      {/* <main className="main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/resume" element={<ResumePage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main> */}
        <main className="main">
        <section id="home">
          <HomePage />
        </section>

        <section id="about">
          <AboutPage />
        </section>

        <section id="services">
          <ServicePage />
        </section>

        <section id="resume">
          <ResumePage />
        </section>

        <section id="portfolio">
          <PortfolioPage />
        </section>

        <section id="contact">
          <ContactPage />
        </section>
      </main>
    </div>
  );
}

export default App;
